<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-container fluid class="m-3">
                <b-row>
                    <b-col cols="12">
                        <div class="mb-3">
                            <strong class="text-sm text-md-md text-lg-lg">
                                BY CLICKING THE BOX AT THE END OF THIS DOCUMENT INDICATING YOUR ACCEPTANCE (THE “ACCEPTANCE”) OF THIS ENROLLMENT CONTRACT (THIS “AGREEMENT”), YOU AGREE YOU HAVE READ AND ARE BOUND BY THE TERMS OF THIS AGREEMENT. IF YOU DO NOT AGREE WITH THIS AGREEMENT, YOU MUST NOT ACCEPT THIS AGREEMENT AND MUST NOT CONTINUE WITH THE COURSE REGISTRATION. DOING SO MEANS YOU START AN OFFICIAL WITHDRAWAL PROCESS. IF YOU ACCEPT THIS AGREEMENT, YOU ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTOOD, AND ARE BOUND BY, THE TERMS AND CONDITIONS STATED HEREIN.
                            </strong>
                        </div>
                        <div class="mb-4">
                            <p>This Agreement is by and between you and BAY ATLANTIC UNIVERSITY (the “BAU”) and is
                                effective as of the date of Acceptance (the “Effective Date”). It governs your academic and
                                financial rights and responsibilities as a student in the Mentora College ESL Program. BAU
                                reserves the right to change or modify portions of this Agreement at any time. You will be
                                asked to sign the Agreement for each module you are enrolled at BAU in the Mentora College
                                ESL Program.</p>
                            <strong class="text-sm text-md-md text-lg-lg">
                                This Agreement Covers the Following Current Period of Attendance for the Program:
                                Period of Attendance Start Date: {{form.active_module_start_date}} Period of Attendance End Date: {{form.active_module_end_date}}

                            </strong>
                            <p>
                                This Agreement covers only the above-referenced current period of attendance for the Program. If the
                                courses necessary to complete the Program extend beyond the above-referenced “Period of
                                attendance end date”, as a condition to further enrollment, you will be required to execute a new
                                Enrollment Agreement with BAU’s Mentora College ESL Program to cover the remaining attendance
                                period. </p>
                        </div>
                        <div>
                            <p class="font-weight-bold">A. VERIFICATION OF PERSONAL INFORMATION</p>
                            <p>The following information is pulled from the application form you submitted.</p>
                        </div>

                        <b-row class="d-flex">
                            <!-- Kişisel Bilgiler -->
                            <b-col cols="12" md="6" lg="4" class="mb-3">
                                <b-card
                                    :title="$t('Your Personal Information')"
                                    class="h-100"
                                >
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="name"
                                            :rules="'required'"
                                            v-slot="{ valid, errors }"
                                        >
                                        <b-form-group :label="$t('name')">
                                            <b-form-input v-model="form.name" :disabled="true"/>
                                        </b-form-group>
                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="middle_name"
                                            rules=""
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('middle_name')">
                                                <b-form-input v-model="form.middle_name" :disabled="true" />
                                            </b-form-group>
                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="surname"
                                            :rules="'required'"
                                            v-slot="{ valid, errors }"
                                        >
                                        <b-form-group :label="$t('last_name')">
                                            <b-form-input v-model="form.surname" :disabled="true" />
                                        </b-form-group>
                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="birthdate"
                                            :rules="'required'"
                                            v-slot="{ valid, errors }"
                                        >
                                        <b-form-group :label="$t('date_of_birth')">
                                            <select-date v-model="form.birthdate"/>
                                        </b-form-group>
                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="legal_presence_type"
                                            rules=""
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('legal_presence_type')">
                                                <parameter-selectbox
                                                    :disabled="true"
                                                    code="legal_presence_types"
                                                    :validateError="errors[0]"
                                                    v-model="form.legal_presence_type"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                </b-card>
                            </b-col>

                            <!-- ABD Adresi -->
                            <b-col cols="12" md="6" lg="4" class="mb-3">
                                <b-card
                                    :title="$t('Your Mailing U.S.Address')"
                                    class="h-100"
                                >
                                    <b-col cols="12">
                                        <b-form-group :label="$t('Search your US Address')">
                                            <AddressSearchComponent
                                                :required="false"
                                                v-model="searchAddress"
                                                @selectedAddress="selected"
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="contact_address"
                                            :rules="!isOnlineAndLegalPresenceTypeControl ? 'required' : ''"
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('address')">
                                                <b-form-input
                                                    type="text"
                                                    v-model="form.contact_address"
                                                    :state="errors[0] ? false : valid ? true : null"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="contact_state_id"
                                            :rules="!isOnlineAndLegalPresenceTypeControl ? 'required' : ''"
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('state')">
                                                <state-selectbox
                                                    :validateError="errors[0]"
                                                    v-model="form.contact_state_id"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="contact_city_id"
                                            :rules="!isOnlineAndLegalPresenceTypeControl ? 'required' : ''"
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('city')">
                                                <city-selectbox
                                                    v-model="form.contact_city_id"
                                                    :state_id="form.contact_state_id"
                                                    :validateError="errors[0]"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-row>
                                            <b-col cols="12" sm="6">
                                                <ValidationProvider
                                                    name="apartment"
                                                    rules=""
                                                    v-slot="{ valid, errors }"
                                                >
                                                    <b-form-group :label="$t('apartment')">
                                                        <b-form-input
                                                            type="text"
                                                            v-model="form.apartment"
                                                            :state="errors[0] ? false : valid ? true : null"
                                                        />
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col cols="12" sm="6">
                                                <ValidationProvider
                                                    name="contact_zip_code"
                                                    :rules="!isOnlineAndLegalPresenceTypeControl ? 'required' : ''"
                                                    v-slot="{ valid, errors }"
                                                >
                                                    <b-form-group :label="$t('zip_code')">
                                                        <b-form-input
                                                            v-model="form.contact_zip_code"
                                                            :state="errors[0] ? false : valid ? true : null"
                                                        />
                                                        <b-form-invalid-feedback v-if="errors[0]">
                                                            {{ errors[0] }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card>
                            </b-col>

                            <!-- Ev Adresi -->
                            <b-col cols="12" md="6" lg="4" class="mb-3">
                                <b-card :title="$t('Your Home Address')" class="h-100">
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="address_country_id"
                                            :rules="isOnlineAndLegalPresenceTypeControl ? 'required' : ''"
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('country')">
                                                <country-selectbox
                                                    :validateError="errors[0]"
                                                    v-model="form.address_country_id"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="address"
                                            :rules="isOnlineAndLegalPresenceTypeControl ? 'required' : ''"
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('address')">
                                                <b-form-input
                                                    v-model="form.address"
                                                    :state="errors[0] ? false : valid ? true : null"
                                                />
                                                <b-form-invalid-feedback v-if="errors[0]">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                </b-card>
                            </b-col>

                            <!-- İletişim Bilgileri -->
                            <b-col cols="12" md="6" lg="4" class="mb-3">
                                <b-card :title="$t('Contact Information')" class="h-100">
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="email"
                                            rules="required|email"
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('email')">
                                                <b-form-input
                                                    type="text"
                                                    v-model="form.personal_email"
                                                    :state="errors[0] ? false : valid ? true : null"
                                                />
                                                <b-form-invalid-feedback v-if="errors[0]">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="gsmNo"
                                            rules="required"
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group
                                                :label="
                          isOnlineAndLegalPresenceTypeControl
                            ? $t('phone_number')
                            : $t('gsm_no2')
                        "
                                            >
                                                <PhoneNumberInput
                                                    v-model="mobile_tel"
                                                    :default-country-code="mobileTelCodeFlag"
                                                    :validate-error="errors[0]"
                                                    @update="mobileTelUpdated"
                                                    :no-flag="!isOnlineAndLegalPresenceTypeControl"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="home_tel"
                                            rules=""
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('other_phone')">
                                                <PhoneNumberInput
                                                    ref="phoneInput"
                                                    v-model="form.home_tel"
                                                    @update="otherPhoneUpdate"
                                                    :default-country-code="homeTelCodeFlag"
                                                    :validate-error="errors[0]"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                </b-card>
                            </b-col>

                            <!-- Acil Durum İletişim Bilgileri -->
                            <b-col cols="12" md="6" lg="4" class="mb-3">
                                <b-card
                                    :title="$t('Emergency Contact Information')"
                                    class="h-100"
                                >
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="emergency_person_name"
                                            rules="required"
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('name2')">
                                                <b-form-input v-model="form.emergency_person_name" />
                                                <b-form-invalid-feedback v-if="errors[0]">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="emergency_person_relation"
                                            rules="required"
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('relationship_to_student')">
                                                <b-form-input
                                                    v-model="form.emergency_person_relation"
                                                    :state="errors[0] ? false : valid ? true : null"
                                                />
                                                <b-form-invalid-feedback v-if="errors[0]">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="emergency_person_phone"
                                            rules=""
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('emergency_person_phone')">
                                                <PhoneNumberInput
                                                    v-model="form.emergency_person_phone"
                                                    @update="emergencyPhoneUpdate"
                                                    :default-country-code="emergencyCodeFlag"
                                                    :validate-error="errors[0]"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                </b-card>
                            </b-col>

                            <b-col cols="12" class="mt-3">
                                <b-row class="d-flex align-items-center flex-column flex-md-row  justify-content-md-between">
                                    <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                                        <ValidationProvider
                                            name="status"
                                            rules="required"
                                            v-slot="{ valid, errors }"
                                        >
                                            <div class="d-flex flex-row-reverse">
                                                <b-form-checkbox
                                                    id="checkbox-1"
                                                    v-model="form.status"
                                                    name="checkbox-1"
                                                    value="accepted"
                                                    :unchecked-value="null"
                                                    class="text-sm text-md-md ml-4"
                                                >
                                                </b-form-checkbox
                                                >
                                                <div>
                                                    {{ $t('confirm_information_accuracy') }}
                                                </div>
                                            </div>
                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12" md="4" class="text-md-right mt-3">
                                        <b-button
                                            type="submit"
                                            @click="next"
                                            variant="primary"
                                            class="w-100 w-md-auto"
                                        >
                                            {{ $t('next') }}
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-container>
        </ValidationObserver>
    </div>
</template>
<script>
import StateSelectbox from "@/components/interactive-fields/StateSelectbox.vue";
import EnrollmentAgreementForm from "@/services/EnrollmentAgreementForm";
import {mapGetters} from "vuex";
import CitySelectbox from "@/components/interactive-fields/CitySelectbox.vue";
import CountryService from "@/services/CountryService";
import CityService from "@/services/CityService";
import StateService from "@/services/StateService";
import countryCodeInputData from "@/modules/students/pages/student/contactInformation/countryCodeInputData"
import PhoneNumberInput from "@/components/elements/PhoneNumberInput.vue";
import AddressSearchComponent from "@/components/interactive-fields/AddressSearchComponent.vue";


export default {
    components: {AddressSearchComponent, PhoneNumberInput, CitySelectbox, StateSelectbox},
    data() {
        return {

            phoneData: {
                formattedNumber: '',
                countryCode: '',
                nationalNumber: '',
                fullEvent: {}
            },
            registration_type_text: null,
            iso2: 'US',
            form: {
                address_country_name: null,
                mobile_tel_country_code: 1,
                home_tel_country_code: 1,
                emergency_person_phone_country_code: 1,
            },
            mobile_tel: null,
            countryCodeInputData,
            masks: {
                input: "DD-MM-YYYY",
            },
            users: null,
            code: null,
            otherCode: null,
            emergencyCode: null,
            legalPresenceType: null,
            searchAddress: null,
        }
    },
    computed: {
        ...mapGetters({
            formData: "enrollmentAgreementForm/formData"
        }),
        isOnlineAndLegalPresenceTypeControl() {
            //return ['Online','F-1 Exchange','Exchange'].includes(this.registration_type_text)
            return false;
        },
        emergencyCodeFlag(){
            return this.getCountryCodeByCallingCode(this.formData.emergency_person_phone_country_code)
        },
        homeTelCodeFlag(){
            return this.getCountryCodeByCallingCode(this.formData.home_tel_country_code)
        },
        mobileTelCodeFlag(){
            return this.getCountryCodeByCallingCode(this.formData.mobile_tel_country_code)
        }
    },
    watch: {
        'form.address_country_id'(value) {
            if (value != null) {
                this.selectedCountryName(value)
            }
        },
        'form.contact_city_id'(value) {
            if (value != null) {
                this.selectedCity(value)
            }
        },
        'form.contact_state_id'(value) {
            if (value != null) {
                this.selectedState(value)
            }
        },
    },
    created() {
        this.getData()
    },
    methods: {
        selectedCountryName(value) {
            const config = {
                params: {
                    sort: ('name'),
                    limit: -1
                }
            };
            CountryService.getAll(config)
                .then(response => {
                    const data = response.data.data;
                    const selectedData = data.find(item => item.id === value);
                    this.form.address_country_name = selectedData.name;
                }).catch(err => {
                this.showErrors(err)
            })
        },
        selectedCity(value) {
            CityService.getCity(this.form.contact_state_id)
                .then(response => {
                    const data = response.data.data;
                    const selectedData = data.find(item => item.id === value);
                    this.form.contact_city_name = selectedData.name;
                }).catch(err => {
                this.showErrors(err)
            })
        },
        selectedState(value) {
            const config = {
                params: {
                    limit: -1
                },
            };
            this.options = [];
            StateService.getOptions(config)
                .then(response => {
                    const data = response.data.data;
                    const selectedData = data.find(item => item.id === value);
                    this.form.contact_state_name = selectedData.name;
                })
        },
        async getData() {
            window.scrollTo(0,0)
            let user = await JSON.parse(localStorage.getItem('user'));
            const response = await EnrollmentAgreementForm.getStudentInformation(user.id)
            this.registration_type_text =response.data.data.registration_type_text
            this.legalPresenceType =response.data.data.legal_presence_type
            await this.$store.dispatch('enrollmentAgreementForm/saveFormData', response.data.data);
            this.form = {...this.formData}
            this.mobile_tel = (this.formData.mobile_tel_country_code ?? '') + this.formData.mobile_tel

        },
        async next() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                if (this.otherCode != null) {
                    this.form.home_tel_country_code = '+' + this.otherCode.countryCallingCode
                }
                if (this.emergencyCode != null) {
                    this.form.emergency_person_phone_country_code = '+' + this.emergencyCode.countryCallingCode
                }
                if (this.code != null) {
                    this.form.mobile_tel_country_code = '+' + this.code.countryCallingCode
                    this.form.countryCodeForm = this.code.countryCode
                } else {
                    this.form.mobile_tel_country_code = 1
                    this.form.countryCodeForm = 'US'
                }
                await this.$store.dispatch('enrollmentAgreementForm/saveFormData', this.form);
                await this.$emit('next', 1);
            }
        },
        mobileTelUpdated(event) {
            this.code = event
            this.form.mobile_tel = this.code.nationalNumber;
            this.form.mobile_tel_country_code = '+' + this.code.countryCallingCode
        },
        otherPhoneUpdate(event) {
            this.otherCode = event
            this.form.home_tel = this.otherCode.nationalNumber;
            this.form.home_tel_country_code = '+' + this.otherCode.countryCallingCode
        },
        emergencyPhoneUpdate(event) {
            this.emergencyCode = event
            this.form.emergency_person_phone = this.emergencyCode.nationalNumber;
            this.form.emergency_person_phone_country_code = '+' + this.emergencyCode.countryCallingCode
        },
        selected(event) {
            this.form.contact_state_id = event.state_id
            this.form.contact_city_id = event.city_id
            this.form.contact_zip_code = event.zip_code
            this.form.contact_address = event.street_number+' '+event.street_name
        },
    }
}
</script>
<style scoped>
.card-size {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 600px;
    height: auto;
    padding: 1rem;
    box-sizing: border-box;
}

.auto-height {
    height: auto !important; /* Gerekirse zorunlu olarak otomatik yükseklik sağlar */
}
</style>
